import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { AppSettings } from '../configs/app.settings';
import { EmailInputComponent } from './component/form-inputs/email-input/email-input.component';
import { PhoneInputComponent } from './component/form-inputs/phone-input/phone-input.component';
import { SelectInputComponent } from './component/form-inputs/select-input/select-input.component';
import { TextInputComponent } from './component/form-inputs/text-input/text-input.component';
import { InputFocus } from './component/form-inputs/input-focus.directive';
import { PhonePipe } from './component/form-inputs/phone.pipe';
import { SkeletonComponent } from './component/skeleton/skeleton.component';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgxPaginationModule } from 'ngx-pagination';
import { BrowserHelper } from './helper/browser.helper';
import { RaffleGuard } from './guard/raffle.guard';


@NgModule({
  declarations: [
    InputFocus,
    PhonePipe,
    EmailInputComponent,
    PhoneInputComponent,
    SelectInputComponent,
    TextInputComponent,
    SkeletonComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    HttpClientModule,
    NgxPaginationModule
  ],
  providers: [
    RaffleGuard,
    AppSettings,
    BrowserHelper
    // { // used for global unhandled exception capture and logging to server
    //   provide: ErrorHandler,
    //   useClass: ErrorLoggingService
    // },
  ],
  exports: [
    SkeletonComponent,
    InputFocus,
    PhonePipe,
    EmailInputComponent,
    PhoneInputComponent,
    SelectInputComponent,
    TextInputComponent,
    CommonModule,
    FormsModule,
    IonicModule,
  ]
})
export class CoreModule { }
